<div class="cx-one-ui main-container mx-6">
    <cv-loader [loaderType]="'cxone'" *ngIf="showSpinner"></cv-loader>
    <div class="header-container mb-3 pt-3" id="header-container">
        <div class="left-title-wrapper">
            <div class="breadCrumb" (click)="onBack()" id="page-title">{{pageTitle}}</div>
            <div class="multiline">{{pageHeader}} <span class="subheader">{{subHeader}}</span></div>
        </div>
        <button class="cxone-btn btn-big btn-secondary btn-bg-is-white" cvLocalizedText (click)="onBack()" langSection="Failed_Reports" langKey="Back" id="back-btn">Back</button>
    </div>
    <cxone-omnibar
        id="search-bar"
        [itemCountLabel]="failedImportLabel"
        [isFilterable]="isFilterable"
        [searchPlaceholderText]="searchPlaceholderText"        
        [searchQuery]="searchInput"
        (searchQueryChange)="onSearchCriteriaChange($event)">
    </cxone-omnibar>
    <cxone-grid
        *ngIf="isLocalizationSectionLoaded"
        class="content-container"
        id="failed-import-grid"
        [columnDefs]="failedImportGridHeaders"
        [rowData]="gridData"
        [gridOptions]="failedImportGridOptions">
    </cxone-grid>
</div>